// extracted by mini-css-extract-plugin
export default {"input":"Search_input__klILD","root":"Search_root__eiX89","searchicon":"Search_searchicon__7e+5U","clearIcon":"Search_clearIcon__eIw10"};